import React from 'react'
import classNames from 'classnames'
import { useNavContext } from '@toasttab/shared/src/components/organisms/Navigation/Contentful/useNavContext'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import useWindowSize from '@toasttab/shared/src/hooks/useWindowSize'
import _helpers from '@toasttab/shared/src/globals/_helpers'
import MobileMenuFooter from './MobileMenuFooter'
import { MobileChildMenuProps } from '@toasttab/shared/src/components/organisms/Navigation/Contentful/ContentfulNavigation.d'
import MobileMenuHeader from './MobileMenuHeader'

// Multi-use component that handles subMenu navigation for main nav categories and the region switcher
// Styling and behavior will be the same, but specific funcionality (menu clicks, etc) and content will be different
// This is effectively just a UI wrapper that handles styling, while content and state management is handled by different parents
const MobileChildMenu = ({
  ariaLabel,
  children,
  handleBackButton,
  handleCloseButton,
  id,
  isOpen,
  showFooterMenu,
  title
}: MobileChildMenuProps) => {
  const { headerHeight } = usePageContext()
  const { isMobileNavOpen } = useNavContext()
  const windowSize = useWindowSize()

  const isDesktopLayout = windowSize.width >= 1024
  const isMobileLayout = windowSize.width < 768

  const subMenuClasses = classNames(
    'flex flex-col w-screen bg-white h-100dvh overflow-y-scroll !no-scrollbar pb-6 fixed top-[0px] md:top-auto z-[105] md:z-[90] transition-right md:transition-left ease-out !duration-500 md:border-r md:border-gray-25 w-full md:max-w-[375px] lg:hidden',
    {
      'invisible right-[-800px] md:left-[-500px]':
        !isOpen || !isMobileNavOpen || isDesktopLayout,
      'right-0 md:left-[375px]': isOpen && isMobileNavOpen && !isDesktopLayout
    }
  )

  return (
    <nav
      aria-hidden={!isOpen}
      aria-label={ariaLabel}
      className={subMenuClasses}
      data-testid='MobileChildMenu'
      id={id}
      style={{
        height:
          windowSize.width >= 768
            ? `calc(100dvh - ${headerHeight}px)`
            : '100dvh',
        paddingBottom: 'env(safe-area-inset-bottom)',
        top: windowSize.width >= 768 ? `${headerHeight}px` : '0'
      }}
    >
      <MobileMenuHeader
        handleBackButton={handleBackButton}
        handleCloseButton={handleCloseButton}
        title={title}
      />
      <div className='px-4 py-6'>{children}</div>
      {showFooterMenu && isMobileLayout ? (
        <div className='px-4 pb-4'>
          <MobileMenuFooter />
        </div>
      ) : null}
    </nav>
  )
}

export default MobileChildMenu
